"use client";
import { useContext } from "react";
import Clients from "../home/clients";
import Enterprise from "../home/enterprise";
import Products from "../home/products";
import Container from "../ui/Container";
import SectionsHeader from "../ui/sections-header";
import { languageContext } from "@/contexts/language-context";
import { motion } from "framer-motion";
import Coffrets from "../coffrets";

const translation: any = {
  credit: {
    fr: "* Aucune carte de crédit requise",
    ar: "* لا حاجة إلى بطاقة ائتمان",
    en: "* No credit card required",
  },
  livraison: {
    fr: "* livraison en moins de 48H",
    ar: "* التوصيل في أقل من 48 ساعة",
    en: "* delivery in less than 48 hours",
  },
  acheterPopcard: {
    fr: "Découvrez l'ensemble des solutions Popcard",
    ar: "اكتشف مجموعة حلول Popcard",
    en: "Discover all Popcard solutions",
  },
  subHeading: {
    fr: "Suscitez la curiosité et l’intérêt de vos prospects en étant simple, efficace et innovant",
    ar: "أثِر فضول واهتمام عملائك المحتملين بطريقة سهلة, فعالة ومبتكرة",
    en: "Spark curiosity and interest in your prospects by being simple, effective, and innovative",
  },
  productsHeader: {
    fr: "Cartes",
    en: "Cards",
    ar: "بطاقات",
  },
  giftsHeader: {
    fr: "Idées Cadeaux",
    en: "Gift Ideas",
    ar: "أفكار هدايا",
  },
};

const AcheterMaPopcard = () => {
  const { lang }: any = useContext(languageContext);
  return (
    <main className="bg-neutral-950">
      <Container className={""}>
        <SectionsHeader
          className="pt-16"
          heading={translation.acheterPopcard[lang]}
        />
        <motion.ul
          className="mx-auto text-center mt-4"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{
            opacity: 1,
            y: 0,
            transition: {
              delay: 0.15,
            },
          }}
          viewport={{ once: true }}
        >
          <li className="text-sm text-neutral-500">
            {translation.credit[lang]}
          </li>
          <li className="text-sm text-neutral-500">
            {translation.livraison[lang]}
          </li>
        </motion.ul>

        <div>
          <SectionsHeader
            className="pt-16"
            heading={translation.productsHeader[lang]}
          />
          <Products showHeader={false} className="py-2 md:py-2 px-0!" />
        </div>
        <div>
          <SectionsHeader className="pt-16" heading={"SaaS"} />
          <Enterprise showHeader={false} className="py-2 md:py-2" />
        </div>

        <div id="coffrets">
          <SectionsHeader
            className="pt-16"
            heading={translation.giftsHeader[lang]}
          />
          <Coffrets showHeader={false} className="py-2 md:py-2" />
        </div>
        <Clients />
      </Container>
    </main>
  );
};

export default AcheterMaPopcard;
